import { getCountryDataProvider } from "./regions";

describe("getCountryDataProvider", () => {
    it("should return regions in english if no language is passed in", async () => {
        const defaultRegions = await getCountryDataProvider(undefined);
        const regions = await getCountryDataProvider("en");
        expect(defaultRegions).toEqual(regions);
        expect(regions).toMatchSnapshot();
    });

    it("should return correct regions for german language", async () => {
        const regions = await getCountryDataProvider("de");
        expect(regions).toMatchSnapshot();
    });
});
